module.exports = __webpack_public_path__ + "static/img/column_recommendation3_1.f5629bec.png";